<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #button>
        <div class="rightBtn">
          <template v-if="authority.isAdmin">
            <a
              v-if="isMakerAccount"
              class="csvDownloadStyle"
              :href="csvDownnload"
              target="_blank"
            >
              {{ $t('common.common_csv-download-product') }}
            </a>
            <a
              class="
                linkText--text
                csvLinkStyle
                csvSampleStyle
                font-weight-bold
              "
              :href="csvSampleUrl"
              target="_blank"
            >
              {{ '※' + $t('common.common_csv-sample') }}
            </a>
            <label class="fileInputLabel">
              {{ $t('common.common_csv-import') }}
              <input
                ref="file"
                type="file"
                class="fileInput"
                @change="fileSelected"
              />
            </label>
          </template>
          <NormalButton
            :text="buttonName"
            height="32px"
            width="96px"
            class="text-right"
            @click="dialogInfo.register = true"
          />
          <MasterProductDialog
            v-model="dialogInfo.register"
            @success="registerSuccess()"
          />
        </div>
      </template>
      <template #list>
        <NoneChevronExpansionPanel>
          <template #header>
            <ProductSearch
              class="px-9"
              @inputKeyword="inputKeyword"
              @selectCategory="selectCategory"
              @inputIsEnabled="inputIsEnabled"
            />
          </template>
          <template #content>
            <ProductInfo
              :search="productSearchInfo"
              @edit="edit"
              ref="productInfo"
            />
          </template>
        </NoneChevronExpansionPanel>
      </template>
    </Master>
    <MasterProductDialog
      v-model="dialogInfo.edit"
      :productData="productData"
      :editMode="true"
      @success="editSuccess()"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Master } from '@/components/layouts'
import { MasterProductDialog } from '@/components/layouts/Dialogs'
import ProductSearch from '@/components/layouts/ProductSearchArea/ProductSearchAreaMaster'
import ProductInfo from '@/components/layouts/ProductInfo/Master/ProductInfo'
import { NoneChevronExpansionPanel } from '@/components/items'
import { NormalButton } from '@/components/items'
export default {
  components: {
    Master,
    MasterProductDialog,
    ProductSearch,
    ProductInfo,
    NoneChevronExpansionPanel,
    NormalButton
  },
  data: () => {
    return {
      pageTitle: 'master.product_product-manage',
      buttonName: 'order.order_product-registration',
      productData: {},
      itemKey: 'productId',
      dialogInfo: {
        register: false,
        edit: false
      },
      editMode: false,
      productSearchInfo: {
        keyword: '',
        category: '',
        isEnabled: true
      },
      uploadFile: ''
    }
  },
  methods: {
    ...mapActions('Product', ['fileUpload']),
    ...mapGetters('Common', ['getLangFromState']),
    async init() {
      this.$refs.productInfo.init()
    },
    inputKeyword(...args) {
      const [keyword] = args
      this.productSearchInfo.keyword = keyword
    },
    selectCategory(...args) {
      const [categoryId] = args
      this.productSearchInfo.category = categoryId
    },
    inputIsEnabled(...args) {
      const [isEnabled] = args
      this.productSearchInfo.isEnabled = isEnabled
    },
    async edit(editProductData) {
      this.productData = editProductData
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async fileSelected(event) {
      this.uploadFile = event.target.files[0]

      const formData = new FormData()
      formData.append('uploadFile', this.uploadFile)
      const uploadData = await this.fileUpload(formData)
      if (uploadData) {
        const nameList = uploadData.data.registeredProductList.map((ele) => {
          return ele.nameCn ? `${ele.nameJp}/${ele.nameCn}` : ele.nameJp
        })
        const nameListStr = nameList.join(', ')
        alert(`${this.$t('common.common_register-result')}
${nameListStr}
        `)
        this.init()
      }

      this.$refs.file.value = '' // 初期化
    }
  },
  computed: {
    ...mapGetters('User', ['authority', 'isSalonAccount', 'isMakerAccount']),
    csvDownnload() {
      const lang =
        this.getLangFromState() === 'ja'
          ? ''
          : '?lang=' + this.getLangFromState()
      return (
        process.env.VUE_APP_WEB_API_BASE_URL +
        '/api/order/products/download' +
        lang
      )
    },
    csvSampleUrl() {
      let url = ''
      switch (process.env.VUE_APP_ENV_NAME) {
        case 'production':
          url =
            'https://order-assets.spe-s.com/sample/master-upload/product_upload_sample_20220609.zip'
          break
        case 'staging':
          url =
            'https://stg-order-assets.spe-s.com/sample/master-upload/product_upload_sample_20220609.zip'
          break
        default:
          url =
            'https://dev-order-assets.spe-s.com/sample/master-upload/product_upload_sample_20220609.zip'
      }
      return url
    }
  }
}
</script>
<style scoped lang="scss">
.rightBtn {
  display: flex;
  justify-content: flex-end;
}
.fileInput {
  display: none;
}
.fileInputLabel {
  width: 108px;
  height: 32px;
  margin: 0px 12px 0px 0px;
  padding: 7px 9px 11px 11px;
  border-radius: 4px;
  border: solid 1px #c8cfd7;
  background-color: #fff;
  font-size: 12px;
  color: #6a6a6a;
}
.csvLinkStyle {
  height: 12px;
  margin: 8px 12px 0px 0px;
  font-size: 12px;
  text-decoration: none;
}
.csvDownloadStyle {
  padding: 7px 9px 11px 11px;
  border-radius: 4px;
  border: solid 1px #c8cfd7;
  background-color: #fff;
  color: #6a6a6a;
  height: 32px;
  margin: 0px 12px 0px 0px;
  text-decoration: none;
  font-size: 12px;
}
.csvSampleStyle {
  width: 88px;
}
</style>
